export default __webpack_public_path__ + "static/media/NOVDOM2025.c4292351.png";